<template>
  <section class="custom-textarea">
    <s-textarea
      ref="textarea"
      class="textarea"
      v-model.trim="textarea_input"
      v-show="!input_data.length && !list.length"
      :class="{ error: format_error }"
      :rows="rows"
      :placeholder="tip"
      @change="sChange"
      @keyup.enter.native="sChange(textarea_input)"
      v-bind="$attrs"
      v-on="$listeners"
      :readonly="onlyRead"
    ></s-textarea>
    <div
      v-show="list.length || input_data"
      class="field"
      :class="{ focus: field_focus }"
      :style="`height: ${rows * 30}px;`"
      @click="setFocus('input')"
    >
      <div class="input-tag">
        <div class="inline-flex" v-for="(item, index) in list" :key="item.value + '' + index">
          <s-tag class="mb-1 mr-1" type="default" :close="true" @close="deleteTag(index)">
            <span
              class="edit-tag"
              ref="tag"
              :class="{ error: item.format_error }"
              :contenteditable="true"
              @input="tagInput(item, index)"
              @blur="
                saveTag(item, index)
                blur()
              "
              @focus="fieldFocus()"
              @keypress.enter="blurTag(index, $event)"
              @keypress.tab="blurTag(index, $event)"
              @click.stop
            >
              {{ item.value }}
            </span>
          </s-tag>
        </div>
        <s-input
          ref="input"
          v-model.trim="input_data"
          :width="input_width"
          :class="{ error: format_error }"
          @input="sInput"
          @keyup.enter.native="sChange(input_data)"
          @keyup.delete.native="deleteInput(input_data)"
          @change="sChange"
          @blur="blur"
          :readonly="onlyRead"
        ></s-input>
        <s-icon icon="wrong" class="clear" @click.native="clear()"></s-icon>
        <s-tooltip class="label-tip" :transfer="true" :content="tip" placement="bottom">
          <s-icon icon="question"></s-icon>
        </s-tooltip>
      </div>
    </div>
    <span class="error" v-show="error.status">{{ error.msg }}</span>
    <s-input
      ref="verifyInput"
      class="verify"
      :class="{ hidden: !$attrs.prop || error.status || !list.length }"
      v-model="value"
      v-bind="$attrs"
    ></s-input>
  </section>
</template>

<script>
import { unique } from '@common/js/common'
export default {
  props: {
    value: [Number, String, Object, Array],
    type: {
      type: String,
      default() {
        return 'text'
      },
    },
    rows: {
      type: Number,
      default() {
        return 2
      },
    },
    required: Boolean,
    regexp: RegExp,
    placeholder: String,
    format: {
      type: Object,
      default() {
        return {
          reg: new RegExp(),
          msg: '',
        }
      },
    },
    onlyRead: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let default_width = 15
    let char = ',|;|；|，|\\n|\\|' // 默认对字符串进行分割的字符
    let split_reg = new RegExp(`(?!${char}).+?(?=${char}|$)`, 'g') // 匹配不包含以上字符的所有其他字符，并后面跟着以上字符的字符串
    let type_reg = {
      number: /^\d*$/,
      text: new RegExp(),
      url: new RegExp(
        '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
        'i'
      ),
    }
    let tip = `Use comma, semicolon, or line break to separate multiple inputs.\n${
      this.placeholder ? this.placeholder : ''
    }`

    return {
      tip: tip,
      default_width: default_width,
      char: char,
      split_reg: split_reg,
      input_width: default_width + 'px',
      input_data: '',
      textarea_input: '',
      focus: false,
      list: [],
      result: [],
      error: {
        status: 0,
        msg: 'Can not be empty',
      },
      format_error: false,
      empty_delete: 0, // 记录input为空后删除的次数
      type_reg: type_reg,
      field_focus: false, // 输入区域是否有焦点
      reg: '',
    }
  },
  watch: {
    // 根据输入字符动态修改input宽度
    input_data(value) {
      let length = value.length
      this.input_width = length * 8 + this.default_width + 'px'
      this.setFocus()
    },
    textarea_input(value) {
      this.setFocus()
    },
    value(v) {
      if (this.textarea_input) {
        return
      }
      if (Array.isArray(v)) {
        let tmp = []
        v.forEach(item => {
          tmp.push({
            value: item,
          })
        })
        this.list = tmp
      } else {
        this.list = this.spliceData(v)
      }
    },
  },
  created() {
    this.reg = this.type_reg[this.type || 'text'] || new RegExp()
    let value = this.value
    this.list = Array.isArray(value) ? value : this.spliceData(value)
    this.emit()
  },
  methods: {
    // input自动focus
    inputFocus(ref) {
      this.$refs[ref] && this.$refs[ref].focus()
    },

    setFocus() {
      let timer = setTimeout(() => {
        if (!this.list.length && !this.input_data.length) {
          this.inputFocus('textarea')
        } else {
          this.inputFocus('input')
        }
        this.fieldFocus()
        clearTimeout(timer)
      }, 0)
    },

    fieldFocus() {
      this.field_focus = true
    },

    blur() {
      this.field_focus = false
    },

    blurTag(index, event) {
      let tag = this.$refs['tag'][index]
      tag.blur()
    },

    spliceData(data) {
      let result = []
      if(data){
        let list = data.match(this.split_reg)
        let error = []

        list = [...new Set(list)] // 去重
        for (let i in list) {
          let value = list[i]
          value = value.trim()
          // 保存格式正确的数据
          if (value.length > 0 && this.reg.test(value)) {
            result.push({
              value: value,
              format_error: false,
            })
          } else {
            error.push(value)
          }
        }
        this.input_data = ''
        // 数据格式错误
        if (error.length) {
          this.input_data = error.join(',')
          this.triggerError(1)
        }
        result = [...this.list, ...result]
        result = unique(result, 'value')
      }
      return result
    },

    triggerError(status, parent) {
      let error = this.error
      error.msg = 'Format Error.'
      error.status = status

      parent = parent || this
      parent.format_error = status
    },

    sChange(value) {
      this.getInput(value)
      if (this.$listeners.change) {
        this.$emit('change', this.result)
      }
    },

    // 检查输入数据
    checkValue(value, parent) {
      parent = parent || this
      if (!value.trim().length) {
        this.triggerError(0, parent)
      }
    },

    sInput(value) {
      if (value.trim().length) {
        this.empty_delete = 0
      }
      this.checkValue(value, this)
    },

    tagInput(item, index) {
      let tag = this.$refs['tag'][index]
      let value = tag.innerText

      if (!value.trim().length) {
        this.deleteTag(index)
      }

      this.checkValue(value, item)
    },

    getInput(value) {
      value = value.trim()
      if (!value.length) {
        return
      }
      this.checkValue(value)
      this.list = this.spliceData(value)
      this.textarea_input = ''
      this.emit()
    },

    deleteInput(value) {
      if (!value.trim().length) {
        this.format_error && (this.format_error = false)
        this.empty_delete++
      }
      if (this.empty_delete > 1) {
        // input为空后再退格才删除tag
        this.deleteTag(-1)
        this.empty_delete = 0
      }

      this.sChange(value)
    },

    deleteTag(index) {
      if(this.onlyRead) return;
      if (index >= 0) {
        this.list.splice(index, 1) // 关闭按钮删除tag
      } else if (!this.input_data.trim().length) {
        // 退格键删除tag
        this.list.pop()
      }

      this.emit('del')
    },

    saveTag(item, index) {
      let tag = this.$refs['tag'][index]
      let value = tag.innerText
      if (value.length > 0 && this.reg.test(value)) {
        this.list[index] && (this.list[index].value = value)

        this.triggerError(0, item)
      } else {
        this.triggerError(1, item)
      }
      this.emit()
    },

    clear() {
      if(this.onlyRead) return;
      this.list = []
      this.input_data = ''
      this.checkValue(this.input_data)
      this.emit('clear')
    },

    emit(type) {
      this.result = this.list.map(item => {
        return item.value
      })

      this.$emit('input', this.result)
      this.$refs.verifyInput && this.$refs.verifyInput.change()
      if (type === 'del') {
        this.$emit('del', this.result)
      }
      if (type === 'clear') {
        this.$emit('clear', this.result)
      }
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
.custom-textarea
  width: 100%;
  .field
    &.focus
      border-color: rgba(111,146,235,0.6);
    border:1px solid #ddd;
    padding: 10px;
    position: relative;
    overflow: auto;
    outline: none;
  .tip
    color: #98999c;
  .clear
  .label-tip
    position: absolute;
    right: 4px;
    top: 4px;
    color: #d4d6d9;
    cursor: pointer;
  .label-tip
    top: 20px;
  .input-field
    border: 0;
    display: inline-flex;
    max-width: 100%;
    .input-box
      max-width: inherit;
    input:not([type=radio]):not([type=checkbox])
      border: 0;
      height: 22px;
      padding: 0;
      background: transparent;
      min-width: 18px;
  .input-tag
    display: inline-flex;
    max-width: 100%;
    flex-wrap: wrap;
    .tag
      padding: 2px 0px;
      min-width: auto;
    .edit-tag
      padding: 2px 8px;
      outline: none;
      line-height: normal;
      min-width: 20px;
  .textarea
    width: 100%;
  .error
    color: #ed5565;
    font-size: 12px;
  .verify
    width: 100%;
    input
      width: 0;
      min-width: unset!important;
      height: 0!important;
    .msg
      position: relative;
      display: inline-block;
      left: -3px;
      right: 0;
      &.msg-icon
        top: 2px;
</style>
